import { templateUsesToken } from './template-token';

const VIDEO_LINK_TOKEN = 'videolink';
const VIDEO_LINK_PLACEHOLDER_CODE = 'aB3xQ9kZ';

export const VIDEO_LINK_SAMPLE_URL = 'https://www.smsreminder.co/meet/aB3xQ9kZ';

// The one list of hosts a /meet/ link may redirect to. Owner-approved only;
// every entry must also be a SAFE_HOSTS entry of the monolith SMS link filter.
export const MEETING_HOST_DOMAINS: readonly string[] = [
  'meet.google.com',
  'zoom.us',
  'teams.microsoft.com',
  'teams.live.com',
  'webex.com',
  'whereby.com',
  'doxy.me',
];

const HTTPS_HOST_PATTERN = /^https:\/\/([a-z0-9.-]+)(?:[/?#]|$)/i;

export function templateUsesVideoLink(
  body: string | null | undefined,
): boolean {
  return templateUsesToken(body, VIDEO_LINK_TOKEN);
}

// Same length as a real short link, so segment counts match a real send.
export function buildVideoLinkPlaceholder(baseUrl: string): string {
  return `${baseUrl}/meet/${VIDEO_LINK_PLACEHOLDER_CODE}`;
}

// Preview-only approximation of the server's isAllowedMeetingUrl: it decides
// whether a preview shows a link of the real length, never where a client is
// sent. Regex, not URL, because Apps Script has no URL class.
export function resolvePreviewVideoLink(
  videoLink: string | null | undefined,
): string {
  const host = HTTPS_HOST_PATTERN.exec(videoLink ?? '')?.[1]?.toLowerCase();
  if (!host) return '';
  const allowed = MEETING_HOST_DOMAINS.some(
    (domain) => host === domain || host.endsWith(`.${domain}`),
  );
  return allowed ? VIDEO_LINK_SAMPLE_URL : '';
}
